/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jira_paid_list_nin_merge_onboarding_modal');
	},
};
